import { FiArrowRight } from 'react-icons/fi';

const steps = [
  {
    n: '01',
    title: 'Answer privately',
    body: 'Eligibl asks about your household, income, and situation. The screener is free and does not require an account.',
  },
  {
    n: '02',
    title: 'See what you may qualify for',
    body: 'It matches you to federal and state aid: food, housing, healthcare, and cash assistance.',
  },
  {
    n: '03',
    title: 'The gap we are closing',
    body: 'A match is not the same as receiving the money. Most people stop at a list of programs and never finish the application.',
  },
];

export default function EligiblSubsidies() {
  return (
    <section className="subsidy" id="subsidies">
      <div className="subsidy-inner">
        <p className="work-kicker">Subsidies</p>
        <div className="subsidy-head">
          <h2>Help people get the aid they qualify for.</h2>
          <p>
            <a href="https://eligibl.org">eligibl.org</a> is the public screener. The work ahead is getting from “you may qualify” to the subsidy actually landing.
          </p>
        </div>

        <ol className="subsidy-steps">
          {steps.map((step) => (
            <li key={step.n}>
              <span>{step.n}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ol>

        <div className="subsidy-plan">
          <h3>Plan forward</h3>
          <p>
            Keep the screener free and anonymous. Next, walk someone through the application for the program they matched: what to gather, which form, and where to submit. Then follow the case until the benefit is approved or they know why it was not. The product is the subsidy, not another directory.
          </p>
          <a href="https://eligibl.org" className="learn-more">Open eligibl.org <FiArrowRight /></a>
        </div>
      </div>
    </section>
  );
}
